
<portal to="modal">
  <div
    class="absolute inset-0 z-modal bg-modal flex"
    @click.self.prevent="closeModal('backdrop')"
    @touchend.self.prevent="closeModal('backdrop')"
  >
    <div
      class="m-auto w-full max-w-3xl px-3 sm:px-4"
      @click.self.prevent="closeModal('backdrop')"
      @touchend.self.prevent="closeModal('backdrop')"
    >
      <div class="bg-white dark:bg-gray-700 border-2 border-app rounded shadow cursor-auto max-h-[85vh] flex flex-col">
        <div class="p-3 sm:p-4 border-b border-gray-200 dark:border-gray-600 flex items-center gap-2">
          <div class="flex-1 min-w-0">
            <p class="text-lg sm:text-2xl font-semibold dark:text-white truncate">
              Ostatnio dodane
            </p>
            <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-300">
              Najnowsze punkty na mapach
            </p>
          </div>
          <button
            class="h-11 w-11 inline-flex items-center justify-center rounded hover:text-app dark:text-white dark:hover:text-app"
            @click="closeModal('x')"
          >
            <fa-icon
              icon="fa-solid fa-times"
              fixed-width
            />
          </button>
        </div>

        <div class="overflow-y-auto p-3 sm:p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
          <article
            v-for="point in points"
            :key="`welcome-point-${point.id}`"
            class="border border-app/40 rounded p-2 bg-gray-50 dark:bg-gray-800/40"
          >
            <div class="flex gap-2 sm:gap-3">
              <a
                v-if="ytLink(point)"
                :href="ytLink(point)"
                class="h-20 w-28 sm:h-24 sm:w-36 rounded overflow-hidden shrink-0"
                @click.prevent="openYtFromThumbnail(point)"
                @touchend.prevent="openYtFromThumbnail(point)"
              >
                <VideoThumbnail
                  :target-url="ytLink(point)"
                  :thumbnail-url="ytThumb(point)"
                  :point-id="point.id"
                  object-class="h-20 w-28 sm:h-24 sm:w-36"
                  class="h-20 w-28 sm:h-24 sm:w-36"
                />
              </a>
              <div
                v-else
                class="h-20 w-28 sm:h-24 sm:w-36 rounded overflow-hidden relative bg-gray-300 dark:bg-gray-600 shrink-0"
              >
                <div class="text-app bg-black/25 inset-0 absolute grid place-content-center">
                  <fa-icon
                    icon="fa-solid fa-video-slash"
                    size="2x"
                    fixed-width
                  />
                </div>
              </div>

              <div class="min-w-0 flex-1 flex flex-col">
                <p class="font-semibold text-sm sm:text-base dark:text-white line-clamp-2">
                  {{ point.title }}
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-300 line-clamp-1">
                  {{ mapLabel(point.mapId) }}
                </p>
                <div class="mt-auto pt-2">
                  <button
                    class="w-full sm:w-auto bg-app text-white dark:text-gray-800 px-3 py-2 rounded text-xs sm:text-sm hover:outline outline-2 outline-offset-1 outline-app active:scale-[0.98] touch-manipulation"
                    @click="openPoint(point)"
                  >
                    Na mapie
                  </button>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</portal>
